// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { isString } from "@sequentech/ui-core";
import { setBallotStyle } from "../store/ballotStyles/ballotStylesSlice";
export var EPublishedBallotStyleLookup;
(function (EPublishedBallotStyleLookup) {
    EPublishedBallotStyleLookup["FOUND"] = "FOUND";
    EPublishedBallotStyleLookup["NOT_LOADED"] = "NOT_LOADED";
    EPublishedBallotStyleLookup["NOT_PUBLISHED"] = "NOT_PUBLISHED";
    EPublishedBallotStyleLookup["UNREADABLE"] = "UNREADABLE";
})(EPublishedBallotStyleLookup || (EPublishedBallotStyleLookup = {}));
/**
 * Looks up the ballot style with the given id among those of published
 * publications of the given election event. NOT_PUBLISHED is only returned
 * once the ballot styles have loaded and none of the published ones of that
 * election event has that id; NOT_LOADED and UNREADABLE mean the lookup could
 * not be completed.
 */
export var findPublishedBallotStyle = function (data, ballotStyleId, electionEventId) {
    if (!data) {
        return { status: EPublishedBallotStyleLookup.NOT_LOADED };
    }
    var publishedPublicationIds = new Set(data.sequent_backend_ballot_publication.map(function (publication) { return publication.id; }));
    var ballotStyle = data.sequent_backend_ballot_style.find(function (style) {
        return style.id === ballotStyleId &&
            style.election_event_id === electionEventId &&
            publishedPublicationIds.has(style.ballot_publication_id);
    });
    if (!ballotStyle) {
        return { status: EPublishedBallotStyleLookup.NOT_PUBLISHED };
    }
    if (!isString(ballotStyle.ballot_eml)) {
        return { status: EPublishedBallotStyleLookup.UNREADABLE };
    }
    try {
        return {
            status: EPublishedBallotStyleLookup.FOUND,
            ballotStyle: JSON.parse(ballotStyle.ballot_eml),
        };
    }
    catch (error) {
        console.log("Error loading EML: ".concat(error));
        return { status: EPublishedBallotStyleLookup.UNREADABLE };
    }
};
export var updateBallotStyleAndSelection = function (data, dispatch) {
    var publishedPublications = new Map(data.sequent_backend_ballot_publication.map(function (publication) { return [
        publication.id,
        publication.published_at,
    ]; }));
    var publishedBallotStyles = data.sequent_backend_ballot_style
        .filter(function (ballotStyle) { return publishedPublications.has(ballotStyle.ballot_publication_id); })
        .sort(function (left, right) {
        var publishedAtOrder = publishedPublications
            .get(left.ballot_publication_id)
            .localeCompare(publishedPublications.get(right.ballot_publication_id));
        return (publishedAtOrder ||
            left.ballot_publication_id.localeCompare(right.ballot_publication_id));
    });
    for (var _i = 0, publishedBallotStyles_1 = publishedBallotStyles; _i < publishedBallotStyles_1.length; _i++) {
        var ballotStyle = publishedBallotStyles_1[_i];
        var ballotEml = ballotStyle.ballot_eml;
        if (!isString(ballotEml)) {
            continue;
        }
        try {
            var electionData = JSON.parse(ballotEml);
            var formattedBallotStyle = {
                id: ballotStyle.id,
                ballot_publication_id: ballotStyle.ballot_publication_id,
                publication_published_at: publishedPublications.get(ballotStyle.ballot_publication_id),
                election_id: ballotStyle.election_id,
                election_event_id: ballotStyle.election_event_id,
                tenant_id: ballotStyle.tenant_id,
                ballot_eml: electionData,
                ballot_signature: ballotStyle.ballot_signature,
                created_at: ballotStyle.created_at,
                area_id: ballotStyle.area_id,
                annotations: ballotStyle.annotations,
                labels: ballotStyle.labels,
                last_updated_at: ballotStyle.last_updated_at,
            };
            dispatch(setBallotStyle(formattedBallotStyle));
        }
        catch (error) {
            console.log("Error loading EML: ".concat(error));
            console.log(ballotEml);
            throw error;
        }
    }
};
